import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { NgbCalendar, NgbDate, NgbDateStruct, NgbDatepicker, NgbModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-booking-dialog',
    templateUrl: './booking-dialog.component.html',
    styleUrls: ['./booking-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSnackBarModule,
        NgbModule,
        MatIconModule,
        MatTooltipModule
    ]
})
export class BookingDialogComponent implements OnInit {
  @Input() activity: any;
  userId: string = "";

  constructor(
    private formBuilder: FormBuilder,
    private _snackBar: MatSnackBar,
    private calendar: NgbCalendar
  ) { }
  selected: Date | null;


  bookActivityForm = this.formBuilder.group({
    dateSelectionCtrl: ['', Validators.required],
    slotsSelectorCtrl: ['', Validators.required],
    slotsTotalLeftCtrl: ['', Validators.required],
    totalCostCtrl: ['', Validators.required]
  })

  modelListUnavailable: Date[] = [];
  unavailables: Date[] = [ ];
  modelListAvailable: Date[] = [];
  currentSlotPrice: number;
  currentSlotMax: number;
  signedIn: boolean = false;

  ngOnInit() {
    // TODO: Implement user authentication check
    this.signedIn = false;

    this.currentSlotPrice = this.activity.pricePerPerson - (this.activity.pricePerPerson * this.activity.discountedPrice);
    //this.currentSlotMax = this.activity.slots;

    // let unavailable: ModelUnavailableDatesFilterInput = {
    //   activityID: {
    //     eq: this.activity.id
    //   }
    // };

    // let available: ModelAvailableDatesFilterInput = {
    //   activityID: {
    //     eq: this.activity.id
    //   }
    // };

    // this.AWSAPI.ListUnavailableDates(unavailable).then((result) => {
    //   result.items.forEach((item) => {
    //     this.uDatesStruct = item;

    //     let tempdates: string[] = [];
    //     tempdates = JSON.parse(item.dates);

    //     tempdates.forEach((date) => {
    //       this.modelListUnavailable.push(new Date(date));
    //     })

    //     let testDate: Date = new Date;
    //     const newDate = testDate.getDate();

    //   })
    // }).catch((error: string) => {
    //   console.log("error", error);
    // })

    //this.bookActivityForm.controls.slotsTotalLeftCtrl.setValue(this.activity.slots.toString());

    // this.AWSAPI.ListAvailableDates(available).then((results) => {
    //   results.items.forEach((item) => {
    //     this.modelListAvailable = JSON.parse(item.dates);
    //   })
    // })

  }

  takeSlot() {
    let slotsUsing: number = Number(this.bookActivityForm.controls.slotsSelectorCtrl.value);
    //let slotsTotal: number = this.activity.slots;

    //this.bookActivityForm.controls.slotsTotalLeftCtrl.setValue((slotsTotal - slotsUsing).toString());
    this.bookActivityForm.controls.totalCostCtrl.setValue((this.currentSlotPrice * slotsUsing).toString());
  }

  unavailableFilter = (date: Date): boolean => {
    const day = date.getDate();
    return !this.modelListUnavailable.find((udate: Date) => udate.getDate() == day);
  }

  navigate(datepicker: NgbDatepicker, number: number) {
		const { state, calendar } = datepicker;
		datepicker.navigateTo(calendar.getNext(state.firstDate, 'm', number));
	}

	today(datepicker: NgbDatepicker) {
		const { calendar } = datepicker;
		datepicker.navigateTo(calendar.getToday());
	}

  bookActivity() {
    // TODO: Implement booking creation with Amplify Gen 2
    console.log('Booking submitted:', this.bookActivityForm.value);
    this.bookActivityForm.reset();
    this.openSnackBar("Booking feature coming soon!", "Close");
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }

}
